import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

const PrizeList = ({ luckyWheelPrizes, isMobile }) => {
    const [showAll, setShowAll] = useState(false);
    const { t } = useTranslation(['luckyWheel']);
    const displayedPrizes = showAll ? luckyWheelPrizes : luckyWheelPrizes.slice(0, 3);

    return (
        <div className='prize-list'>
            {(isMobile ? displayedPrizes : luckyWheelPrizes || []).map((item, index) => (
                <div key={item.seq} className='prize-list-item'>
                    <LazyLoadImage className='prize-number' src={`/public/html/images/lucky-wheel/prize-${index + 1}.png`} alt='prize-number' />
                    {item.prizeName}
                    <LazyLoadImage className='prize-gift' src={item?.image || '/public/html/images/lucky-wheel/gift.png'} alt='gift' />
                </div>
            ))}

            {luckyWheelPrizes.length > 3 && isMobile && (
                <button className='view-more-button' onClick={() => setShowAll(!showAll)}>
                    {showAll ? t('luckyWheel.viewLess') : t('luckyWheel.viewMore')}
                </button>
            )}
        </div>
    );
};

export default PrizeList;
